import { httpApi } from '@app/api/http.api';
import { UserModel } from '@app/domain/UserModel';

export interface AuthData {
  email: string;
  password: string;
}

export interface SignUpRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface ResetPasswordRequest {
  email: string;
}

export interface SecurityCodePayload {
  code: string;
}

export interface NewPasswordData {
  id: number;
  password: string;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: UserModel;
}

export interface UserLoginResponse {
  id: number;
  token: string;
  refreshToken: string;
  isFirstTimeLogin: boolean;
}

export interface UserRefreshTokenResponse {
  id: number;
  accessToken: string;
}

export const login = (loginPayload: LoginRequest): Promise<UserLoginResponse> =>
  httpApi.post<UserLoginResponse>('/apim/v1/authenticate', { ...loginPayload }).then(({ data }) => data);

export const setNewPassword = (newPasswordData: NewPasswordData): Promise<undefined> =>
  httpApi.post<undefined>('/apim/v1/resetfirstloginpassword', { ...newPasswordData }).then(({ data }) => data);

export const refreshToken = (): Promise<UserRefreshTokenResponse> =>
  httpApi.get<UserRefreshTokenResponse>('/apim/v1/refreshtoken').then(({ data }) => data);

export const logout = (): Promise<undefined> => httpApi.post<undefined>('/apim/v1/logout').then(({ data }) => data);

export const signUp = (signUpData: SignUpRequest): Promise<undefined> =>
  httpApi.post<undefined>('signUp', { ...signUpData }).then(({ data }) => data);

export const resetPassword = (resetPasswordPayload: ResetPasswordRequest): Promise<undefined> =>
  httpApi.post<undefined>('forgotPassword', { ...resetPasswordPayload }).then(({ data }) => data);

export const verifySecurityCode = (securityCodePayload: SecurityCodePayload): Promise<undefined> =>
  httpApi.post<undefined>('verifySecurityCode', { ...securityCodePayload }).then(({ data }) => data);
